// extracted by mini-css-extract-plugin
export default {"container":"AuthorBanner_container__jMBLc","content":"AuthorBanner_content__Wv-gl","authorName":"AuthorBanner_authorName__M0N9i","workContainer":"AuthorBanner_workContainer__AgDqj"};